import { render, staticRenderFns } from "./TermsofService.vue?vue&type=template&id=3add04ee&scoped=true&"
import script from "./TermsofService.vue?vue&type=script&lang=js&"
export * from "./TermsofService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3add04ee",
  null
  
)

export default component.exports